module.exports = __webpack_public_path__ + "img/cheveronUp.aa8190de.svg";